import React from 'react';
import { object, string } from 'yup';
import { startCase } from 'lodash';

import { env } from '~/commons/config';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '../../../commons/components/FormCheckGroup.jsx';
import FormResource from './FormResource.jsx';

const ps = env?.permission?.segments ?? [];
const pa = env?.permission?.actions ?? [];

const defaultPermission = ps.map((segment) => ({
  segment,
  action: pa.at(-1) ?? 'none',
}));
const defaults = {
  name: '',
  permission: defaultPermission,
};
const schema = () => object({
  name: string().required(),
});
const roleKey = {
  departments: 'Users Account',
  roles: 'User Roles',
  terms: 'Terms & Conditions',
};

const FormRole = ({ role }) => (
  <FormResource
    {...{
      defaults,
      schema: schema(),
      stored: role
        ? (() => {
          let { permission } = role;
          permission = defaultPermission.map(
            (p) => permission.find((d) => d.segment === p.segment) || p,
          );
          return { ...role, permission };
        })()
        : undefined,
      api: '/api/core/roles',
      onSubmit: (v) => v,
    }}>
    <FormGroup name="name" label="Name" />

    <h6 className="small border-bottom text-muted py-1 pt-4 mb-3">Permission</h6>
    <div>
      <div className="row mb-2">
        <div className="col-6 font-weight-bold">Module</div>
        <div className="col-6 font-weight-bold">Action</div>
      </div>
      {ps.map((segment, i) => (
        <div className="row py-1 highlight border-bottom" key={segment}>
          <div className="col-6">{roleKey[segment] ?? startCase(segment)}</div>
          <div className="col-6">
            <div className="row">
              {[
                { value: 'edit', display: 'Full Control' },
                { value: 'read', display: 'Read Only' },
                { value: 'none', display: 'Disabled' },
              ].map(({ value, display }) => (
                <div className="col" key={`${segment}-${value}`}>
                  <FormCheckGroup
                    name={`permission[${i}].action`}
                    label={display}
                    value={value}
                    type="radio"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  </FormResource>
);

export default FormRole;
